import { render, staticRenderFns } from "./send.vue?vue&type=template&id=0085c689&"
import script from "./send.vue?vue&type=script&lang=ts&"
export * from "./send.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports